// extracted by mini-css-extract-plugin
module.exports = {"image":"Card_image__36R52"};